/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InsuranceCode/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function InsuranceCode({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/InsuranceCode"
  
}) {
let chargeInsuranceCodeCodeValueData = fromData.useDataValue({ viewPath,
context: 'charge',
path: 'insurance_code.code',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="charge.insurance_code.code"
 text={chargeInsuranceCodeCodeValueData}
 size="small"
/>
{children}
</React.Fragment>)
}